import { createContext, useContext, useMemo } from 'react';

const TopicMemberRequestContext = createContext();

export const TopicMemberRequestProvider = ({
  children,
  handleSubmitRequest,
  requestApproval,
  isLoading,
  isSubmitting,
  isEditing,
  handleEdit,
  isCanceling,
  handleCancel,
}) => {
  const value = useMemo(
    () => ({
      handleSubmitRequest,
      requestApproval,
      isLoading,
      isSubmitting,
      isEditing,
      handleEdit,
      isCanceling,
      handleCancel,
    }),
    [
      handleSubmitRequest,
      requestApproval,
      isLoading,
      isSubmitting,
      isEditing,
      handleEdit,
      isCanceling,
      handleCancel,
    ],
  );

  return (
    <TopicMemberRequestContext.Provider value={value}>
      {children}
    </TopicMemberRequestContext.Provider>
  );
};

export const useTopicMemberRequestContext = () =>
  useContext(TopicMemberRequestContext);

export default TopicMemberRequestContext;
